import {
    ExtendedAccountColumns,
    ExtendedAccountData,
    ExtendedAddress,
} from '@/backend/features/contact-management/entities/extended-account/types';
import { AdditionAccountHeaderContent } from '@/ui/features/accounts/components';
import { AccountDetails, AccountDetailsProps } from '@juvare/contact-management/ui/features/accounts/components/AccountDetails';
import { PersonOccupationData } from '@juvare/credentialing/backend/extraTypes';
import { OccupationInformation, PersonSubtitle } from '@juvare/credentialing/ui/features/person-credentials';
import { useProfessionalStatuses } from '@juvare/credentialing/ui/hooks';
import { GetResponse } from '@juvare/platform-shared/features/storage';
import React from 'react';

// TODO: remove this after PFCRED-96 is fixed.
export const fixOccupationProfessionalStatusCredentialLicenses = (
    occupations: PersonOccupationData[] | undefined,
    professionalStatusCredentialId: string,
) => {
    if (!occupations) {
        return undefined;
    }

    return occupations.map((occupation) => {
        if (occupation.credentials && occupation.credentials?.[professionalStatusCredentialId]?.licenses?.length === 0) {
            return {
                ...occupation,
                credentials: {
                    ...occupation.credentials,
                    [professionalStatusCredentialId]: {
                        ...occupation.credentials?.[professionalStatusCredentialId],
                        licenses: undefined,
                    },
                },
            };
        }

        return occupation;
    });
};

export const RmsAccountDetails: React.FC<AccountDetailsProps> = (props) => {
    const { professionalStatusCredentialId } = useProfessionalStatuses();
    const extendedAccount = props.account as GetResponse<ExtendedAccountData, ExtendedAccountColumns>;
    const address = props.account.data.address as ExtendedAddress;

    return (
        <AccountDetails
            {...props}
            subTitle={<PersonSubtitle tribeId={address?.tribeId} county={address?.county} residenceType={address?.residenceType} />}
            additionalHeaderContent={<AdditionAccountHeaderContent account={extendedAccount.data} cardStyle='slideout' />}
            additionalContent={
                <OccupationInformation
                    personData={{
                        ...extendedAccount.data,
                        occupations: fixOccupationProfessionalStatusCredentialLicenses(
                            extendedAccount.data.occupations,
                            professionalStatusCredentialId,
                        ),
                    }}
                />
            }
        />
    );
};
